import { Loader, NumberInput, NumberInputProps } from '@mantine/core';
import { FC, useState } from 'react';

interface Props extends NumberInputProps {
  onBlurSave: (val: string) => Promise<boolean>;
}

const BookitupNumberInput: FC<Props> = ({ onBlurSave, ...rest }) => {
  const [updating, setUpdating] = useState(false);

  // eslint-disable-next-line no-underscore-dangle
  const _onBlur = async (val: string) => {
    setUpdating(true);
    await onBlurSave(val);
    setUpdating(false);
  };

  return (
    <NumberInput
      hideControls
      onBlur={(e) => _onBlur(e.currentTarget.value)}
      {...rest}
      rightSection={updating ? <Loader size="xs" /> : rest.rightSection}
    />
  );
};

export default BookitupNumberInput;
